import { IPromise, IHttpService } from "angular";
import { IInstanceSettings, IDashboardData } from "../../typings/board/Models";

export const DASHBOARD_SERVICE = "dashboardService";

export class DashboardService {
    static $inject = ["$http"];
    constructor(private $http: IHttpService) { }
    servicesToWatch(): IPromise<string[]> {
        return this.$http.get<string[]>("api/dashboard/ServicesToWatch").then(response => response.data);
    }
    processorId(): IPromise<string> {
        return this.$http.get<string>("api/dashboard/ProcessorId").then(response => response.data);
    }
    machineName(): IPromise<string> {
        return this.$http.get<string>("api/dashboard/MachineId").then(response => response.data);
    }
    instanceSettings(): IPromise<IInstanceSettings> {
        return this.$http.get<IInstanceSettings>("api/dashboard/InstanceSettings").then(response => response.data);
    }

    getDashboardData(): IPromise<IDashboardData> {
        return this.$http.get<IDashboardData>("api/dashboard/GetDashboardData").then(response => response.data);
    }
}


// WEBPACK FOOTER //
// ./app/dashboard/dashboard.service.ts